import { __assign, __awaiter, __extends, __generator } from "tslib";
import endsWith from 'lodash-es/endsWith';
import { mmUid } from 'mm-ts-utils';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ARBITRARY_ID_BUBBLE_COMMAND, ARBITRARY_ID_INITIAL_DATA, ARBITRARY_ID_UI_STATE, CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES, CUSTOM_MESSAGE_TYPE_MARKER, DOMAIN_TYPE_ARBITRARY, } from '../../../consts';
import { ChatMessageType } from '../../../_library/domain-base/BaseChatMessage';
import { ChatThreadClass } from '../../chat/components/ChatThread/ChatThread';
import { domainAction, domainSelector } from '../../domain/domain-redux';
import { url } from '../url';
import { replaceApiAdapterConfigHash } from '../utils/api-helpers';
import { getClientConfig, setSessionTheadId } from '../utils/app-storage';
import { createDebugLogger, parseUrl } from '../utils/app-utils';
import { getThreadId } from '../../domain/selectors/get-thread-id';
import { startChat } from '../../chat/actions/start-chat';
import { continueChat } from "../../chat/actions/continue-chat";
export var BUBBLE_MSG_ROOM = 'BUBBLE';
export var BUBBLE_MSG_TYPE_ECHO = 'ECHO';
export var BUBBLE_MSG_TYPE_HELLO = 'HELLO';
export var BUBBLE_MSG_TYPE_COMMAND = 'COMMAND';
export var BUBBLE_MSG_TYPE_INITIAL_DATA = 'INITIAL_DATA';
export var BUBBLE_MSG_TYPE_UI_STATE = 'UI_STATE';
export var BUBBLE_MSG_TYPE_NEW_CONFIG_HASH = 'BUBBLE_MSG_TYPE_NEW_CONFIG_HASH';
export var BUBBLE_MSG_TYPE_START_CHAT = 'BUBBLE_MSG_TYPE_START_CHAT';
export var BUBBLE_MSG_TYPE_CONTINUE_CHAT = 'BUBBLE_MSG_TYPE_CONTINUE_CHAT';
export var SIEBEL_SET_INFO = 'SIEBEL_SET_INFO';
// could be potentially configurable...
export var BUBBLE_MSG_TARGET_ORIGIN = '*';
// https://www.google.com/search?client=firefox-b-d&q=detect+if+in+iframe
var isInIframe = function () {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
var debug = createDebugLogger('BubbleChannel');
var BubbleChannelClass = /** @class */ (function (_super) {
    __extends(BubbleChannelClass, _super);
    function BubbleChannelClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debug = createDebugLogger('BubbleChannel');
        _this.onMessage = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var m, dispatch, receivalPayload, _a, _b, conversationId, voiceId, sblInteractionId, agentId;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        m = e.data;
                        dispatch = this.props.dispatch;
                        // we are handling here only 'bubble' namespaced messages
                        if (m.room !== BUBBLE_MSG_ROOM) {
                            this.debug('Ignoring unknown message: %O', m);
                            return [2 /*return*/];
                        }
                        _a = m.type;
                        switch (_a) {
                            case BUBBLE_MSG_TYPE_ECHO: return [3 /*break*/, 1];
                            case BUBBLE_MSG_TYPE_INITIAL_DATA: return [3 /*break*/, 2];
                            case BUBBLE_MSG_TYPE_NEW_CONFIG_HASH: return [3 /*break*/, 4];
                            case BUBBLE_MSG_TYPE_UI_STATE: return [3 /*break*/, 5];
                            case SIEBEL_SET_INFO: return [3 /*break*/, 6];
                            case BUBBLE_MSG_TYPE_START_CHAT: return [3 /*break*/, 7];
                            case BUBBLE_MSG_TYPE_CONTINUE_CHAT: return [3 /*break*/, 8];
                        }
                        return [3 /*break*/, 9];
                    case 1:
                        if (m.payload && BubbleChannelClass._pendingCallbacks.has(m.payload.id)) {
                            BubbleChannelClass._pendingCallbacks.get(m.payload.id)(m.payload.response);
                            BubbleChannelClass._pendingCallbacks.delete(m.payload.id);
                        }
                        return [3 /*break*/, 10];
                    case 2: return [4 /*yield*/, this._onInitialData(m.payload)];
                    case 3:
                        receivalPayload = _e.sent();
                        return [3 /*break*/, 10];
                    case 4:
                        replaceApiAdapterConfigHash(m.payload);
                        window.location.href = url.HOME();
                        return [3 /*break*/, 10];
                    case 5:
                        dispatch(domainAction.mergeModelsPayload((_c = {},
                            _c[DOMAIN_TYPE_ARBITRARY] = (_d = {}, _d[ARBITRARY_ID_UI_STATE] = m.payload, _d),
                            _c)));
                        return [3 /*break*/, 10];
                    case 6:
                        _b = m.payload, conversationId = _b.conversationId, voiceId = _b.voiceId, sblInteractionId = _b.sblInteractionId, agentId = _b.agentId;
                        ChatThreadClass.submitMessage({ dispatch: dispatch, identity: null, threadId: conversationId }, JSON.stringify({
                            type: CUSTOM_MESSAGE_TYPE_MARKER,
                            room: CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES,
                            payload: {
                                named_entities: {
                                    SiebelStatus: 'OK',
                                    voiceId: voiceId,
                                    sblInteractionId: sblInteractionId,
                                    agentId: agentId,
                                },
                            },
                        }), ChatMessageType.HIDDEN);
                        return [3 /*break*/, 10];
                    case 7:
                        this.debug("Start Chat Command Received.");
                        dispatch(startChat(this.props.history));
                        return [3 /*break*/, 10];
                    case 8:
                        this.debug("Continue Chat Command Received.");
                        dispatch(continueChat(this.props.history));
                        return [3 /*break*/, 10];
                    case 9:
                        this.debug("Ignoring message. No handler for type '".concat(m.type, "'."));
                        _e.label = 10;
                    case 10:
                        // aby sme sa drzali konvencie komunikacneho kanalu, tak notifikujeme
                        // odosielatela, ze sme obdrzali spravu (a mozno aj nejaky payload mu
                        // vraciame)...
                        BubbleChannelClass._confirmReceival(m, receivalPayload);
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    BubbleChannelClass.postMessage = function (payload, type, cb) {
        if (!isInIframe()) {
            return false;
        }
        var id = mmUid();
        if (typeof cb === 'function') {
            BubbleChannelClass._pendingCallbacks.set(id, cb);
        }
        BubbleChannelClass.parentBubblePostMessage({
            id: id,
            type: type,
            payload: __assign(__assign({}, (payload || {})), { timestamp: new Date() }),
        });
    };
    BubbleChannelClass.postCommand = function (command, data, cb) {
        if (!isInIframe()) {
            return false;
        }
        var id = mmUid();
        if (typeof cb === 'function') {
            BubbleChannelClass._pendingCallbacks.set(id, cb);
        }
        BubbleChannelClass.parentBubblePostMessage({
            id: id,
            type: BUBBLE_MSG_TYPE_COMMAND,
            room: BUBBLE_MSG_ROOM,
            payload: { command: command, data: data, timestamp: new Date() },
        });
    };
    BubbleChannelClass.prototype.componentDidMount = function () {
        // IMPORTANT - return early as NOOP if app is NOT loaded as iframe
        if (!isInIframe()) {
            return;
        }
        this.debug("Enabling bubble channel...");
        window.addEventListener('message', this.onMessage);
        // Let the parent window (bubble) know we're ready. This is important because
        // bubble knows this iframe is loaded and can send initial data here.
        BubbleChannelClass.parentBubblePostMessage({
            type: BUBBLE_MSG_TYPE_HELLO,
            payload: { timestamp: new Date() },
        });
    };
    BubbleChannelClass.prototype.componentDidUpdate = function (prevProps) {
        var bubbleCommandPayload = this.props.bubbleCommandPayload;
        // IMPORTANT: prevProps.bubbleCommandPayload !== bubbleCommandPayload
        if (bubbleCommandPayload &&
            prevProps.bubbleCommandPayload !== bubbleCommandPayload) {
            var commandPayloads = Array.isArray(bubbleCommandPayload)
                ? bubbleCommandPayload
                : [bubbleCommandPayload];
            commandPayloads.forEach(function (bcp) {
                var command = bcp.command, data = bcp.data;
                BubbleChannelClass.postCommand(command, data);
            });
            // IMPORTANT!
            this.props.dispatch(domainAction.deleteModelByEntityTypeAndId(DOMAIN_TYPE_ARBITRARY, ARBITRARY_ID_BUBBLE_COMMAND));
            // handle redirect command
            var redirectCommandPayload = commandPayloads.find(function (bcp) { return bcp.command === 'REDIRECT'; });
            if (redirectCommandPayload) {
                var data = redirectCommandPayload.data;
                var conversationId = data === null || data === void 0 ? void 0 : data.conversationId;
                if (conversationId && conversationId !== this.props.threadId) {
                    // reload page
                    var forcePageReload = false; // implications of either use are yet to be determined
                    this.debug("Redirecting to conversation: ".concat(conversationId));
                    // setup existing conversation
                    setSessionTheadId(conversationId);
                    if (forcePageReload) {
                        window.location.href = url.CHAT(conversationId);
                    }
                    else {
                        this.props.history.push(url.CHAT(conversationId));
                    }
                }
            }
        }
    };
    BubbleChannelClass.prototype.render = function () {
        return null;
    };
    BubbleChannelClass.parentBubblePostMessage = function (message) {
        var isEcho = message.type === BUBBLE_MSG_TYPE_ECHO;
        // defaults (for non-ECHOs)
        if (!isEcho) {
            message.id = message.id || mmUid();
        }
        message.room = message.room || BUBBLE_MSG_ROOM;
        !isEcho && debug("--> SEND", message);
        window.parent.postMessage(message, BUBBLE_MSG_TARGET_ORIGIN);
    };
    BubbleChannelClass.prototype._onInitialData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var whitelist, _clientHostname, _parentHostname_1, isIpLike, isAllowed, dispatch, id;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        whitelist = (getClientConfig().IFRAME_ALLOW_FROM_DOMAIN_WHITELIST || '')
                            .split(',')
                            .map(function (v) { return "".concat(v).trim(); })
                            .filter(function (v) { return !!v; });
                        _clientHostname = parseUrl(null, 'hostname');
                        if (data && data._url && whitelist.length) {
                            _parentHostname_1 = parseUrl(data._url, 'hostname');
                            isIpLike = /^[\d.]+$/.test(_parentHostname_1);
                            // ips, localhost and sameorigin are always allowed
                            if (!isIpLike &&
                                _parentHostname_1 !== 'localhost' &&
                                _parentHostname_1 !== _clientHostname) {
                                isAllowed = whitelist.some(function (domain) {
                                    return endsWith(_parentHostname_1.toLowerCase(), domain.toLowerCase());
                                });
                                if (!isAllowed) {
                                    console.error("NOT ALLOWED: \"".concat(_parentHostname_1, "\" not found in \"").concat(whitelist, "\""));
                                    this.props.history.replace(url.NOT_ALLOWED());
                                    return [2 /*return*/];
                                }
                            }
                        }
                        dispatch = this.props.dispatch;
                        id = ARBITRARY_ID_INITIAL_DATA;
                        // tu pouzijeme standarnu "domain model" konvenciu a nase inital data si
                        // ulozime ako domenovy typ "ARBITRARY" a id zaznamu bude "initial_data"
                        dispatch(domainAction.mergeModelsPayload((_a = {},
                            _a[DOMAIN_TYPE_ARBITRARY] = (_b = {}, _b[id] = __assign(__assign({}, data), { id: id }), _b),
                            _a)));
                        if (!(typeof BubbleChannelClass.onInitialDataCustomHandler === 'function')) return [3 /*break*/, 2];
                        return [4 /*yield*/, BubbleChannelClass.onInitialDataCustomHandler(this, data)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BubbleChannelClass._confirmReceival = function (m, response) {
        if (m.id) {
            debug("--> (Echo: ".concat(m.id, ")"), response);
            BubbleChannelClass.parentBubblePostMessage({
                type: BUBBLE_MSG_TYPE_ECHO,
                payload: { id: m.id, response: response },
            });
        }
    };
    BubbleChannelClass.COMMAND_SHOW = 'SHOW';
    BubbleChannelClass.COMMAND_HIDE = 'HIDE';
    BubbleChannelClass.COMMAND_OPEN = 'OPEN';
    BubbleChannelClass.COMMAND_CLOSE = 'CLOSE';
    BubbleChannelClass.COMMAND_TOGGLE = 'TOGGLE';
    BubbleChannelClass.COMMAND_SET_TEXT = 'SET_TEXT';
    BubbleChannelClass.COMMAND_OPEN_FULLSCREEN_ON = 'OPEN_FULLSCREEN_ON';
    BubbleChannelClass.COMMAND_OPEN_FULLSCREEN_OFF = 'OPEN_FULLSCREEN_OFF';
    BubbleChannelClass.COMMAND_OPEN_FULLSCREEN_TOGGLE = 'OPEN_FULLSCREEN_TOGGLE';
    BubbleChannelClass.COMMAND_GET_STATE = 'GET_STATE';
    BubbleChannelClass._pendingCallbacks = new Map();
    return BubbleChannelClass;
}(React.Component));
export { BubbleChannelClass };
var mapStateToProps = function (state, ownProps) {
    var bubbleCommandMessage = domainSelector.getByTypeAndId(state)(DOMAIN_TYPE_ARBITRARY, ARBITRARY_ID_BUBBLE_COMMAND);
    return {
        bubbleCommandPayload: (bubbleCommandMessage || {}).payload,
        threadId: getThreadId(state),
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return ({
        dispatch: dispatch,
    });
};
var connected = connect(mapStateToProps, mapDispatchToProps)(BubbleChannelClass);
export var BubbleChannel = withRouter(connected);
